var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.50464V5.11286C5.25 3.97788 6.09499 3.01479 7.22608 2.92091C7.59937 2.88993 7.97386 2.86322 8.34952 2.84083M12.75 17.0046H15C16.2426 17.0046 17.25 15.9973 17.25 14.7546V5.11286C17.25 3.97787 16.405 3.01479 15.2739 2.92091C14.9006 2.88993 14.5261 2.86322 14.1505 2.84083M12.75 17.7546V15.8796C12.75 14.0157 11.239 12.5046 9.375 12.5046H7.875C7.25368 12.5046 6.75 12.001 6.75 11.3796V9.87964C6.75 8.01568 5.23896 6.50464 3.375 6.50464H2.25M14.1505 2.84083C13.8672 1.92221 13.0116 1.25464 12 1.25464H10.5C9.48842 1.25464 8.63276 1.92221 8.34952 2.84083M14.1505 2.84083C14.2152 3.05066 14.25 3.27358 14.25 3.50464V4.25464H8.25V3.50464C8.25 3.27358 8.28483 3.05066 8.34952 2.84083M3.75 6.50464H1.875C1.25368 6.50464 0.75 7.00832 0.75 7.62964V19.6296C0.75 20.251 1.25368 20.7546 1.875 20.7546H11.625C12.2463 20.7546 12.75 20.251 12.75 19.6296V15.5046C12.75 10.5341 8.72056 6.50464 3.75 6.50464Z",
    stroke: "#0084FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/clone-icon.5c73ce38be64c1b5472ba719b16bc164.svg";
export { ForwardRef as ReactComponent };